module.exports = __webpack_public_path__ + "static/media/logoTwoBlack.6816c067.svg";